import { useState } from "react";
import BulkAssetLinks from '@/components/bulk_asset_links.js';
import ProductDownloadsSection from '@/components/product_downloads_section.js'; 
import PhotometricDownloadsSection from '@/components/photometric_downloads_section.js'; 

export default function ResourceSection ({downloads, product, config, resource_display, _classes }) {
 const [show, setShow] = useState(false);

  return  (
    <div  className={_classes ? _classes : "lexcms-product-downloads-section" }>
      {Object.keys(downloads || {}).map((resourceCategory, i) => {
        const slicedDownloads =
          resource_display === "modal"
            ? downloads[resourceCategory]?.slice(0, 3)
            : downloads[resourceCategory];
        const photometricDownloadsSection = (resourceCategory === 'Photometry') && slicedDownloads.find((d, v) => d.photometry_viewer )

        const allCategoryDownloads = downloads[resourceCategory] || []
        return (
           photometricDownloadsSection ? (
             <PhotometricDownloadsSection i={i} config={config} 
               product={product} 
               resourceCategory={resourceCategory}
               resource_display={resource_display}
               show={show} allDownloads={allCategoryDownloads} 
               setShow={setShow}  slicedDownloads={slicedDownloads }  />

           ) : 
          <ProductDownloadsSection i={i} config={config} 
                                    product={product} 
                                    resourceCategory={resourceCategory}
                                    resource_display={resource_display}
                                    allDownloads={allCategoryDownloads}
                                    show={show} 
                                    setShow={setShow}  slicedDownloads={slicedDownloads }  />
        );
      })}
      <BulkAssetLinks product={product} config={config} />
    </div>

  )
}

 

